// Main entry point - imports and initializes everything
// This file lives in static/js/, so imports are relative to this directory

// First, import apps.js (which will import all its dependencies)
import './apps.js';

// Then, import and run keyboard integration
import { autoIntegrateKeyboard } from './apps-keyboard-integration.js';

// Import debug interface (exposes window.navDebug)
import './apps-kb-debug.js';

// Execute keyboard integration after apps.js has loaded
autoIntegrateKeyboard();
